import Card from './Card'
export type { CardProps } from './Card'
export default Card
